export default __webpack_public_path__ + "static/media/closet5-after2-1024w.db6761d2.avif";